import React from 'react';

import IconButton from '@mui/material/IconButton';
import ReportIcon from '@mui/icons-material/Report';

import { Message, StyledInfoMessage } from './styles';
import { FindIcon } from './icons';

/**
 *
 * @param {message} string - @default 'Mensagem não definida'
 * Adiciona uma mensagem ao InfoMessage | Default é 'Mensagem não definida'
 *
 * @param {snackColor} string - @default '#fff'
 * HEX ou nome da cor, muda a cor do InfoMessage | Default é '#'
 *
 * @param {width} string - @default '100%'
 * Tamanho do InfoMessage | Default é '100%'
 *
 * @param {messageAlign} string - @default 'center'
 * Alinhamento da mensagem | Default é 'center'
 *
 * @param {icon} string - @default 'ReportIcon'
 * Icone referente ao MateriaUI Icons, icones novos precisam ser adicionados
 * no arquivo ./icons.js. Lá também contém os icones existentes |
 *
 */
function InfoMessage({
  message = 'Mensagem não definida',
  snackColor = '#ffffff',
  align = 'center',
  fontSize = '16px',
  minWidth = '360px',
  padding = '0px 35px',
  icon,
}) {
  function renderIcon() {
    const MaterialIcon = FindIcon(icon);
    return (
      <IconButton style={{ color: '#5b5959' }}>
        {MaterialIcon !== '' ? MaterialIcon : <ReportIcon />}
      </IconButton>
    );
  }

  return (
    <StyledInfoMessage
      style={{
        borderRadius: '50px',
        boxShadow: 'none',
        minWidth,
        padding,
      }}
      snackColor={snackColor}
      align={align}
      message={
        <>
          {renderIcon()}
          <Message style={{ color: '#5b5959', fontSize }}>{message}</Message>
        </>
      }
    />
  );
}

export default InfoMessage;
